import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { commonLabelConstants } from '../../constants/label-constants';

@Component({
  selector: 'app-delete-role-confirm-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})

export class ConfirmationDialogComponent {

  action: string;
  ImageSrc:any;
  labelConstants:any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: { action: string }) {
    this.action = data.action;
  }
  
  ngOnInit(): void {
    this.labelConstants = commonLabelConstants
  }
}